export const ROOT_ROUTE = "/";
export const LOGIN_ROUTE = "/login";
export const REGISTRATION_ROUTE = "/register-club";
export const HOME_ROUTE = "/club/teams";
export const POSTS_ROUTE = "/news";
export const SCHEDULE_ROUTE = "/activities";
export const MANAGER_HOME_ROUTE = HOME_ROUTE;
export const BILLING_ROUTE = "/billing";
export const CLUB_ROUTE = "/club";
export const CLUB_TEAMS_ROUTE = "/club/teams";
export const CLUB_FIELDS_ROUTE = "/club/fields";
export const CLUB_FORMS_ROUTE = "/club/forms";
export const FILES_ROUTE = "/files";
export const SHOP_ROUTE = "/shop";
export const STAFF_ROUTE = "/staff";
export const FORMS_ROUTE = "/forms";
export const NOTIFICATIONS_ROUTE = "/notifications";
export const PLAYERS_ROUTE = "/players";
export const ACCOUNT_SETTINGS_ROUTE = "/settings/account";
export const SUPER_ADMIN_CLUBS_ROUTE = "/super-admin/clubs";
export const SUPER_ADMIN_IMPERSONATE_ROUTE = "/super-admin/impersonate";
export const SUPER_ADMIN_ROLES_ROUTE = "/super-admin/roles";

export const ROOT_PATH = "/";
export const WILDCARD_PATH = "*";
export const SPLAT_PATH = "/*";

export const LOGIN_SPLAT_ROUTE = `${LOGIN_ROUTE}${SPLAT_PATH}`;
export const CLUB_SPLAT_ROUTE = `${CLUB_ROUTE}${SPLAT_PATH}`;
export const FILES_SPLAT_ROUTE = `${FILES_ROUTE}${SPLAT_PATH}`;
export const SHOP_SPLAT_ROUTE = `${SHOP_ROUTE}${SPLAT_PATH}`;
export const FORMS_SPLAT_ROUTE = `${FORMS_ROUTE}${SPLAT_PATH}`;
export const BILLING_SPLAT_ROUTE = `${BILLING_ROUTE}${SPLAT_PATH}`;
export const ACTIVITIES_SPLAT_ROUTE = `${SCHEDULE_ROUTE}${SPLAT_PATH}`;
export const PLAYERS_SPLAT_ROUTE = `${PLAYERS_ROUTE}${SPLAT_PATH}`;
export const NOTIFICATIONS_SPLAT_ROUTE = `${NOTIFICATIONS_ROUTE}${SPLAT_PATH}`;

export const CLUB_TEAMS_PATH = "/teams/*";
export const CLUB_FIELDS_PATH = "/fields";
export const CLUB_FORMS_PATH = "/forms";

export const INDEX_ROUTE_PATH = "/";
export const TEAM_DETAILS_PATH = "/:id";
export const TEAM_MOVE_PLAYERS_PATH = "/:id/move-players";
export const TEAM_PLAYER_CREATE_PATH = "/:teamId/players/create";
export const PLAYER_TEAM_DETAILS_PATH = "/:teamId/:id";
export const PLAYER_EDIT_PATH = "/:id/edit";
export const PLAYER_TEAM_EDIT_PATH = "/:teamId/:id/edit";
export const FORM_ASSIGN_PATH = "/:formId/assign";
export const FORM_DETAILS_PATH = "/:formId";
export const FORM_CREATE_PATH = "/create-form";
export const ACTIVITY_EDIT_PATH = "/edit/:activityId/*";
export const ACTIVITY_CREATE_PATH = "/create/*";
export const ACTIVITY_CREATE_TRAINING_PATH = "/training";
export const ACTIVITY_CREATE_MATCH_PATH = "/match";
export const ACTIVITY_CREATE_EVENT_PATH = "/event";
export const SHOP_ADD_PRODUCT_PATH = "/add-product/:type";
export const SHOP_EDIT_PRODUCT_PATH = "/products/:id/edit/:type";
export const SHOP_VIEW_PRODUCT_PATH = "/products/:id/view";
export const SHOP_CREATE_ORDER_PATH = "/order/:id/create";

export const FORM_CREATE_ROUTE = `${FORMS_ROUTE}${FORM_CREATE_PATH}`;

export const getPlayerDetailsRoute = (playerId, teamId) =>
  teamId
    ? `${PLAYERS_ROUTE}/${teamId}/${playerId}`
    : `${PLAYERS_ROUTE}/${playerId}`;

export const getPlayerEditRoute = (playerId, teamId) =>
  `${getPlayerDetailsRoute(playerId, teamId)}/edit`;

export const getTeamPlayerCreateRoute = (teamId) =>
  `${CLUB_TEAMS_ROUTE}/${teamId}/players/create`;

export const LOGIN_SESSION_EXPIRED_ROUTE = `${LOGIN_ROUTE}?error=login_session_expired`;
